import { KeyValueModel } from "model";
import { EnumSexo } from "model/enums/enum-sexo";

export const SexoMock: KeyValueModel[] = [
    new KeyValueModel(EnumSexo.NaoInformado, "Não Informado"),
    new KeyValueModel(EnumSexo.Masculino, "Masculino"),
    new KeyValueModel(EnumSexo.Feminino, "Feminino"),
];
